/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useState } from "react";
import PersonalisedForYou from "./PersonalisedForYou";
import { useDispatch, useSelector } from "react-redux";
import { fetchKeyTakeaways } from "../../redux/personaliseLessons/keyTakeawaySlice";
import { BarLoader, SyncLoader } from "react-spinners";
import {
  fetchCourseModule,
  selectCourseModule,
} from "../../redux/personaliseLessons/courseModuleSlice";
import { toast } from "react-toastify";
import {
  fetchLessonDetails,
  selectLessonDetails,
} from "../../redux/personaliseLessons/lessonDetailsSlice";
import { selectAuthentication } from "../../redux/personaliseLessons/authenticationSlice";
import { selectCourseList } from "../../redux/personaliseLessons/courseListSlice";
import { Mixpanel } from "../../config/Mixpanel";
import constants from "./utilities/constants";
import { fetchLessonQuiz } from "../../redux/personaliseLessons/lessonQuizSlice";
import jsPDF from "jspdf";

const KeyTakeAway = ({ userGoal, setUserGoal, course_slug, lesson_slug }) => {
  const [keytakeawayLoading, setKeyTakeawayLoading] = useState(false);
  const courseModule = useSelector(selectCourseModule);
  const existingUserGoal = courseModule?.user_goal;
  const lessonDetails = useSelector(selectLessonDetails)?.lesson_data;
  const videoId = lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1];
  const lesson_name = lessonDetails?.lesson_name;
  const lessonId = lessonDetails?.lesson_id;
  const uid = useSelector(selectAuthentication)?.uid;
  const subject_name = useSelector(selectCourseList)?.courseName;
  const dispatch = useDispatch();

  useEffect(() => {
    if (existingUserGoal.length > 0 && lessonDetails?.keypoints?.length === 0) {
      setKeyTakeawayLoading(true);
      const fetchData = async () => {
        try {
          await dispatch(
            fetchKeyTakeaways({
              user_id: uid,
              video_id: videoId,
              goal: existingUserGoal,
              skill: lesson_name,
              lesson_id: lessonId,
              subject: course_slug,
            }),
          );
          await dispatch(
            fetchLessonDetails({
              uid: uid,
              subject: subject_name,
              lesson_slug: lesson_slug,
            }),
          );
          setKeyTakeawayLoading(false);
        } catch (error) {
          console.log(error.message);
          setKeyTakeawayLoading(false);
          throw error;
        }
      };
      fetchData();
    }
  }, [lesson_slug, lessonDetails?.keypoints?.length]);

  const handleSubmit = (e) => {
    e.preventDefault();
    Mixpanel.track(
      constants.Mixpanel.LESSON_PAGE_USER_GOAL_FROM_KEYTAKEAWAY_WAS_CLICKED,
    );
    if (userGoal.length <= 0) {
      return toast.error("Enter your goal");
    }
    const fetchData = async () => {
      setKeyTakeawayLoading(true);
      try {
        await dispatch(
          fetchKeyTakeaways({
            user_id: uid,
            video_id: videoId,
            goal: userGoal,
            skill: lesson_name,
            lesson_id: lessonId,
            subject: subject_name,
          }),
        );
        // The first action has completed and its response is received
        await dispatch(
          fetchLessonQuiz({
            user_id: uid,
            video_id: videoId,
            subject: subject_name,
            lesson_id: lessonId,
            goal: userGoal,
            skill: lesson_name,
          }),
        );
        await dispatch(
          fetchCourseModule({
            uid: uid,
            subject_name: subject_name,
          }),
        );
        await dispatch(
          fetchLessonDetails({
            uid: uid,
            subject: subject_name,
            lesson_slug: lesson_slug,
          }),
        );
        setKeyTakeawayLoading(false);
      } catch (error) {
        // Handle any errors that may occur during the dispatch
        console.error("Error:", error);
      }
    };
    fetchData();
    setUserGoal("");
  };

  const generatePDF = () => {
    const pdf = new jsPDF();
    const keypoints = lessonDetails?.keypoints?.split("\n") || [];
    pdf.setFontSize(16);
    pdf.text("Keypoints", 10, 10);
    pdf.setFontSize(12);
    let yPos = 20;
    keypoints.forEach((keypoint, index) => {
      const maxWidth = 180;
      const lines = pdf.splitTextToSize(keypoint, maxWidth);
      lines.forEach((line, lineIndex) => {
        pdf.text(line, 10, yPos + lineIndex * 5);
      });
      yPos += lines.length * 5 + 5;
    });
    pdf.save("keytakeways.pdf");
  };

  return (
    <>
      {!existingUserGoal?.length > 0 ? (
        !keytakeawayLoading ? (
          <div className="p-4">
            <h2 className="text-xl font-semibold lg:hidden">Key Takeaways</h2>
            <p className="my-2.5 text-sm italic leading-[17px] opacity-50">
              Provide us your goal and we’ll personalise key takeaways for you.
            </p>
            <p className="mt-10 mb-1.5 text-sm font-medium">
              With this course, I want to _______
            </p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Get a job as a data scientist, get a raise of..."
                value={userGoal}
                onChange={(e) => setUserGoal(e.target.value)}
                className="goal w-full rounded-xl border-none bg-[#17395A] placeholder:text-sm"
              />
              <div className="mt-4 flex justify-end">
                <button
                  type="submit"
                  disabled={!userGoal.length > 0}
                  className="cursor-pointer rounded-xl bg-[#7FC241] py-2 px-5 disabled:opacity-50"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="flex h-[276px] w-full flex-col items-center justify-center">
            <p className="mb-2">Loading</p>
            <BarLoader color="#7FC241" />
          </div>
        )
      ) : lessonDetails?.lesson_status === "completed" ||
        lessonDetails?.lesson_status === "inprogress" ||
        lessonDetails?.lesson_status === "quizpending" ? (
        !keytakeawayLoading ? (
          <div className="p-3 lg:p-6">
            <div className="flex items-center justify-between lg:hidden">
              <h2 className="text-xl font-semibold">Key Takeaways</h2>
              <PersonalisedForYou />
            </div>
            <div
              id="keytakeways"
              className="takeaway mt-4 h-[228px] overflow-y-scroll pr-1 pt-1 text-sm leading-[17px] lg:mt-0"
              style={{ scrollBehavior: "smooth" }}
            >
              {lessonDetails?.keypoints?.split("\n")?.map((item, index) => (
                <p className="mb-3" key={index}>
                  {item}
                </p>
              ))}
            </div>
            <div
              className="mt-3 flex w-fit cursor-pointer items-center gap-2 rounded-lg border px-3 py-1.5"
              onClick={generatePDF}
            >
              <p className="text-sm">Download</p>
              <img
                src="https://img.learntube.ai/public-assets/Lead%20Generation/Vector%20(11).png?updatedAt=1713357285665"
                width={14}
                height={14}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div className="flex h-[228px] w-full flex-col items-center justify-center">
            <p className="mb-2">Loading</p>
            <SyncLoader color="#7FC241" />
          </div>
        )
      ) : (
        <div className="relative p-6 lg:h-[228px]">
          <h2 className="text-xl font-semibold lg:hidden">Key Takeaways</h2>
          <div className="mt-3 blur">
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Esse
              fuga suscipit, in, architecto veniam excepturi repellendus.
            </p>
            <p className="mt-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet
              hic veniam, fuga delectus nostrum nemo possimus.
            </p>
            <p className="mt-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet
              hic veniam, fuga delectus nostrum nemo possimus.
            </p>
          </div>
          <div className="absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 transform flex-col items-center text-center">
            <img
              src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Lock_6.svg?updatedAt=1689232670218"
              width={21}
              height={27}
              alt=""
            />
            <p className="font-medium">Watch Video To Unlock</p>
          </div>
        </div>
      )}
    </>
  );
};

export default KeyTakeAway;
